import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import { IMG } from "../data/content";

export const About = () => (
  <section data-testid="about-section" id="unternehmen" className="py-20 lg:py-32">
    <div className="container-blum">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="relative lg:col-span-7">
          <div className="img-zoom relative">
            <img src={IMG.aboutTeam} alt="Die Geschäftsführung von Fussboden Blum – drei Generationen" className="w-full aspect-[4/5] object-cover object-top" />
          </div>
          <div className="absolute -bottom-8 -right-4 lg:-right-8 bg-[#D32F2F] text-white p-8 max-w-[240px] shadow-xl">
            <p className="font-display text-5xl font-bold leading-none">55+</p>
            <p className="mt-2 text-sm text-white/90 leading-snug">Jahre Erfahrung in Parkett & Fußbodentechnik</p>
          </div>
        </Reveal>

        <div className="lg:col-span-5">
          <Reveal><p className="overline">Unternehmen</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="text-3xl lg:text-4xl font-bold tracking-tight mt-4 leading-tight">
              Drei Generationen Erfahrung – und das Handwerk liegt uns noch immer am Herzen.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-[#6B6B73] text-lg leading-relaxed mt-6">
              Fussboden Blum ist kein günstiger Massenanbieter, sondern ein regionaler Qualitätsbetrieb.
              Als Meisterbetrieb mit mehrfach ausgezeichneter Ausbildung und TÜV-zertifizierter
              Raumakustik-Kompetenz stehen wir für Verlässlichkeit, persönliche Beratung und
              handwerkliche Sorgfalt.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-[#6B6B73] text-lg leading-relaxed mt-4">
              Bei uns finden Sie keinen Katalog, sondern eine Einladung zum Gespräch. Vom ersten
              Beratungstermin bis zur fertigen Fläche – alles aus einer Hand.
            </p>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="flex flex-wrap gap-4 mt-10">
              <Link to="/unternehmen" data-testid="about-unternehmen-btn" className="btn-base btn-navy">Lernen Sie uns kennen</Link>
              <Link to="/produkte" data-testid="about-produkte-btn" className="btn-base btn-outline">Unsere Produkte</Link>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
